(() => {
  const guide = document.querySelector('.w-guide');
  if (!guide) return;

  const stops = [...guide.querySelectorAll('[data-guide-step]')];
  const poses = [...guide.querySelectorAll('.w-guide-pose')];
  const figure = guide.querySelector('.w-guide-figure');
  const counter = guide.querySelector('.w-guide-counter');
  const progress = guide.querySelector('.w-guide-progress');
  const toggle = guide.querySelector('.w-guide-toggle');
  const smallScreen = window.matchMedia('(max-width: 760px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const positions = [
    { x: -14, y: 4, scale: 1, rotation: -1 },
    { x: 28, y: -4, scale: 1.022, rotation: 1 },
    { x: -18, y: 0, scale: 1.015, rotation: -0.5 },
    { x: 22, y: -4, scale: 1.025, rotation: 0.8 },
    { x: 0, y: 2, scale: 1.01, rotation: 0 }
  ];

  let paused = false;
  let scheduled = false;

  const clamp = (number, min, max) => Math.min(max, Math.max(min, number));
  const ease = value => value * value * (3 - 2 * value);
  const motionEnabled = () => !smallScreen.matches && !reducedMotion.matches;

  function render() {
    scheduled = false;
    if (!motionEnabled()) {
      document.documentElement.classList.remove('has-guide-motion');
      stops.forEach(stop => stop.classList.remove('is-current'));
      return;
    }

    document.documentElement.classList.add('has-guide-motion');
    const viewportFocus = window.innerHeight * .53;
    const centers = stops.map(stop => {
      const box = stop.getBoundingClientRect();
      return box.top + box.height / 2;
    });

    let position = 0;
    if (viewportFocus >= centers[centers.length - 1]) {
      position = centers.length - 1;
    } else if (viewportFocus > centers[0]) {
      for (let index = 0; index < centers.length - 1; index++) {
        if (viewportFocus >= centers[index] && viewportFocus <= centers[index + 1]) {
          const fraction = (viewportFocus - centers[index]) / (centers[index + 1] - centers[index]);
          // A short hold around each stop lets the accompanying image settle.
          position = index + ease(clamp((fraction - .14) / .72, 0, 1));
          break;
        }
      }
    }

    const selected = Math.round(position);
    stops.forEach((stop, index) => stop.classList.toggle('is-current', index === selected));
    counter.textContent = String(selected + 1).padStart(2, '0') + ' / 05';
    if (paused) return;

    const before = Math.floor(position);
    const after = Math.min(before + 1, positions.length - 1);
    const mix = position - before;
    const interpolate = key => positions[before][key] +
      (positions[after][key] - positions[before][key]) * mix;

    figure.style.setProperty('--guide-x', interpolate('x') + 'px');
    figure.style.setProperty('--guide-y', interpolate('y') + 'px');
    figure.style.setProperty('--guide-scale', interpolate('scale'));
    figure.style.setProperty('--guide-rotate', interpolate('rotation') + 'deg');
    poses.forEach((pose, index) => {
      pose.style.opacity = index === before ? String(1 - mix) :
        index === after ? String(mix) : '0';
    });
    progress.style.setProperty('--guide-progress', (position / (stops.length - 1) * 100) + '%');
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(render);
  }

  toggle.addEventListener('click', () => {
    paused = !paused;
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.setAttribute('aria-label', paused ? 'Resume guide motion' : 'Pause guide motion');
    toggle.innerHTML = paused ? 'Resume motion <span aria-hidden="true">▶</span>' :
      'Pause motion <span aria-hidden="true">Ⅱ</span>';
    if (!paused) schedule();
  });

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  smallScreen.addEventListener('change', schedule);
  reducedMotion.addEventListener('change', schedule);
  render();
})();
